import AntSkeleton from "antd/es/skeleton";
import styled from "styled-components";

export const Skeleton = styled(AntSkeleton)<{ $height?: number }>`
  h3 {
    margin-bottom: 0;
    ${(p) =>
      p.$height &&
      `
      height: ${p.$height}px !important;
    `};
  }
  ${(p) =>
    p.theme.isDarkMode &&
    `
    background: rgba(0, 0, 0, 0.13);
    .ant-skeleton-title {
      background: rgba(0, 0, 0, 0.13);
    }
  `};
`;

Skeleton.Avatar = styled(AntSkeleton.Avatar)`
  ${(p) =>
    p.theme.isDarkMode &&
    `
    background: rgba(0, 0, 0, 0.13);
    .ant-skeleton-avatar {
      background: rgba(0, 0, 0, 0.13);
    }
  `};
`;
